import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { GeneralInfoTab } from "@/pages/ContactsPage/Tabs";
import { GeneralInfoDesktop } from "./components";

export const GeneralInfoTabContent = () => {
  return <ResponsiveBlockSwitcher desktop={<GeneralInfoDesktop />} mobile={<GeneralInfoTab />} />;
};
